module.exports = __webpack_public_path__ + "0ce87659dfa8c8fc42abdc2c45160286.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-5.png
// module id = 3297
// module chunks = 0